import React from 'react';
import PropTypes from 'prop-types';
import { Button, Dialog, FormControl, IconButton, Input, InputAdornment, InputLabel, List, ListItem, Select, TextField } from '@material-ui/core';
import {get } from 'lodash';
import MultipleSelectFilter from '@peoplenet/vi-components-ui/src/NewLibraryFilter/component/MultipleSelectFilter';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import { I18n } from 'react-redux-i18n';
import SearchIcon from "@material-ui/icons/Search";
export default class SearchableMultipleSelectFilter extends React.Component {
    static propTypes = {
        label: PropTypes.string,
        value: PropTypes.arrayOf(PropTypes.string),
        options: PropTypes.arrayOf(PropTypes.shape({
            id: PropTypes.string.isRequired,
            name: PropTypes.string.isRequired,
            children: PropTypes.arrayOf(PropTypes.shape({}))
        })),
        type: PropTypes.string
    }
    static defaultProps = {
        value: [],
        options: [],
        type: ''
    }
    constructor(props){
        super(props);
        const {value, options} = props;
        this.state = {
            selected: value,
            open: false,
            listValues: [...options],
            searchText: ''
        };
    }
    componentWillReceiveProps(newProps) {
        if(newProps.value !== this.props.value){
            this.setState({selected: newProps.value});
        }
    }
    handleTextSearch = event => {
        let value = get(event, 'target.value');
        this.setState({searchText: value});
    }
    handleOpen = () => {
        //DOM manipulation to position the paper dialog to align to the start of the button position.
        setTimeout(() => {
            try {
                const btnEle = document.getElementById('filter_btn_'+this.props.type);
                if(btnEle && btnEle.getBoundingClientRect() && btnEle.getBoundingClientRect().left){
                    const leftPos = btnEle.getBoundingClientRect().left - 50;
                    const targetEle = document.getElementsByClassName('searchableMultiSelect__paper '+this.props.type)[0];
                    if(targetEle && leftPos > 0 ){
                        targetEle.style.left = `${leftPos}px`;
                    }     
                }
            } catch (error) {
                
            }
            
        }, 5);
        this.setState({open: true});
    }
    handleClose = () => {
        this.setState({open: false, selected: this.props.value});
    }
    handleOnClear = () => {
        this.setState({selected: []});
        this.props.onChange();
        this.handleClose();
    }
    handleOnFilter = () => {
        this.props.onChange(this.state.selected);
        this.handleClose();
    }
    handleData = (values) => {
        this.setState({selected: values});
    }
    renderOption = (option, paddingLeft = 0, checked) => {
        const isChecked = checked || includes(this.state.selected, option.id);
        let options = [];
        options = (
            <li
              key={option.id}
              value={option.id}
              style={{paddingLeft: `${paddingLeft}px`}}
            >
              <Checkbox checked={isChecked} />
              {option.name}
            </li>
        );
    
        const children = get(option, 'children', []);
        options = concat(options,
          map(children, child => this.renderOption(child, paddingLeft + 20, isChecked)));
          
        return options;
    }
    
    renderOptions = () => {
        return map(this.props.options, item => this.renderOption(item));
    }
    render() {
        return (
            <div className="librarylist desktopfilters__list">
                <FormControl className='librarylist__formcontrol'>
                    <Button onClick={this.handleOpen} variant="contained" style={{ width: 'auto', justifyContent: 'left', textTransform: 'capitalize'}} className="chip__datepickerchip filtertype-label" title={this.props.label} id={"filter_btn_"+this.props.type}>
                        {this.props.label}
                        <ArrowDropDownIcon style={{ color: 'white', position: 'absolute', right: '5px'}}/>
                    </Button>
                    <Dialog 
                        open={this.state.open}
                        onClose={this.handleClose}
                        BackdropProps={{
                            invisible: true
                        }}
                        classes={{
                            root: 'searchableMultiSelect',
                            paper: 'searchableMultiSelect__paper '+this.props.type
                        }}
                    >
                        <FormControl className='librarylist__formcontrol'>
                            <TextField label="" InputProps={{
                                endAdornment: (<InputAdornment><IconButton><SearchIcon /></IconButton></InputAdornment>)
                            }} onChange={this.handleTextSearch} className="librarylist__searchField"/>
                            <List className="searchableMultiSelect__cont">
                                <MultipleSelectFilter 
                                    options={this.props.options}
                                    label={this.props.label}
                                    value={this.state.selected}
                                    showList={true}
                                    searchText={this.state.searchText}
                                    onChange={this.handleData}
                                />
                            </List>
                            <List>
                                <ListItem className="desktopfilters__actions">
                                    <Button variant="contained" onClick={this.handleOnClear} id="dateFilterClear" className="btn btn-secondary">{I18n.t('action.clear')}</Button>
                                    <Button variant="contained" color="primary" id="dateFilterApply" className="btn btn-primary" onClick={this.handleOnFilter}>{I18n.t('action.apply')}</Button>
                                </ListItem>
                            </List>
                        </FormControl>
                    </Dialog>
                </FormControl>
            </div>
        )
    }
}
